import gettEnv from '../../config/gettEnv';

const scrumNumber = () => {
    return process.env.PUBLIC_URL.replace('/', '');
};

const gatewayPath = () => {
    // localhost mode
    if (process.env.NODE_ENV === 'development') {
        return ``;
    }
    if (gettEnv.PARAM_ENV !== 'prod') {
        return `https://rider-gateway.scrum${scrumNumber()}.gett.io`;
    }
    return `https://b2cgateway.gett.com`;
};

export default gatewayPath;
